import { render, staticRenderFns } from "./supplierQuotationsAudit.vue?vue&type=template&id=550b3e2b&"
import script from "./supplierQuotationsAudit.vue?vue&type=script&lang=js&"
export * from "./supplierQuotationsAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports